module.exports = "/static/assets/dc8cb58ef0a7e70cf3ed030c3621013e.png";